import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { getPagePartSlug } from '@gov-nx/module/page/definitions/PageMap';
import AuthorizedRoute from '../../routes/AuthorizedRoute';
import { DataBoxNewMessage } from './DataBoxNewMessage';

const DataBoxLayout = lazy(() =>
	import('../../layouts/DataBox/DataBoxLayout').then(({ DataBoxLayout }) => ({
		default: DataBoxLayout,
	}))
);
const DataBoxMessagesLayout = lazy(() =>
	import('../../layouts/DataBox/DataBoxMessagesListLayout').then(
		({ DataBoxMessagesListLayout }) => ({
			default: DataBoxMessagesListLayout,
		})
	)
);
const DataBoxMessageDetail = lazy(() =>
	import('./DataBoxMessageDetail').then(({ DataBoxMessageDetail }) => ({
		default: DataBoxMessageDetail,
	}))
);
const DataBoxMessageAnswer = lazy(() =>
	import('./DataBoxMessageAnswer').then(({ DataBoxMessageAnswer }) => ({
		default: DataBoxMessageAnswer,
	}))
);

const DataBoxMessageAnother = lazy(() =>
	import('./DataBoxMessageAnother').then(({ DataBoxMessageAnother }) => ({
		default: DataBoxMessageAnother,
	}))
);
const DataBoxActionInfo = lazy(() =>
	import('./DataBoxActionInfo').then(({ DataBoxActionInfo }) => ({
		default: DataBoxActionInfo,
	}))
);
const DataBoxConnectPage = lazy(() =>
	import('./DataBoxConnectPage').then(({ DataBoxConnectPage }) => ({
		default: DataBoxConnectPage,
	}))
);

export const getDataBoxRoutes = (): RouteObject[] => [
	{
		path: '/ds/zalozeni-navrat',
		element: <Navigate to={`/${getPagePartSlug('datove-schranky')}`} />,
	},
	{
		path: getPagePartSlug('datove-schranky'),
		element: (
			<AuthorizedRoute>
				<DataBoxLayout />
			</AuthorizedRoute>
		),
		children: [
			{
				path: getPagePartSlug('datove-schranky.schranka'),
				element: <DataBoxMessagesLayout />,
				children: [
					{
						index: true,
						element: <DataBoxActionInfo />,
					},
					{
						path: getPagePartSlug('datove-schranky.schranka.zprava'),
						children: [
							{
								index: true,
								element: <DataBoxMessageDetail />,
							},
							{
								path: getPagePartSlug(
									'datove-schranky.schranka.zprava.odpoved'
								),
								element: <DataBoxMessageAnswer />,
							},
							{
								path: getPagePartSlug('datove-schranky.schranka.zprava.dalsi'),
								element: <DataBoxMessageAnother />,
							},
						],
					},
					{
						path: getPagePartSlug('datove-schranky.schranka.nova-zprava'),
						children: [
							{
								index: true,
								element: <DataBoxNewMessage />,
							},
						],
					},
				],
			},
		],
	},
	{
		path:
			getPagePartSlug('nastaveni') +
			'/' +
			getPagePartSlug('nastaveni.datove-schranky'),
		element: <DataBoxConnectPage />,
	},
];
